module.exports = __webpack_public_path__ + "static/media/lamps-plus-large_2x.d0627689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/lamps-plus-large_2x.png
// module id = 836
// module chunks = 27